import { type QueryView, ViewFlagValue, isNodeOwned } from "~/models/dto";
import { namableAlphabeticalSorter } from "~/tools/namable-alphabetical-sorter";
import { not } from "~/tools/not";

export const isViewLockProtected = (view: QueryView): boolean =>
	isNodeOwned(view) && (view.flags?.includes(ViewFlagValue.NotUnlockable) ?? false);

export const shouldHideFromOverview = (view: QueryView): boolean =>
	view.flags?.includes(ViewFlagValue.HideFromViewsOverview) ?? false;

export function filterCustomViews(views: ReadonlyArray<QueryView>): Array<QueryView> {
	return views.filter(not(shouldHideFromOverview)).sort(namableAlphabeticalSorter);
}
